<template lang="html">
  <nav
    v-click-outside="hideDropdown"
    class="main-navigation"
    @mouseleave="hideDropdown"
  >
    <ul class="main-navigation__list">
      <li
        v-for="item in items"
        :key="item.id"
        class="main-navigation__item"
        @mouseenter="activeItem = item.id"
      >
        <AppLink
          :is-link="!!item.targetPage.url"
          :to="item.targetPage.url"
          class="main-navigation__text"
        >
          <span class="main-navigation__link">{{ item.readableName }}</span>
        </AppLink>
        <transition name="dropdown">
          <Dropdown
            v-if="item.children && item.children.length"
            v-show="$store.state.ui.pageHeaderVisible && activeItem === item.id"
            visible
          >
            <SubNavigation :items="item.children" />
          </Dropdown>
        </transition>
      </li>
    </ul>
  </nav>
</template>

<script>
import SubNavigation from 'beisheim/components/elements/sub-navigation'
import Dropdown from 'beisheim/components/elements/dropdown'
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    SubNavigation,
    Dropdown,
    AppLink
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      activeItem: null
    }
  },
  methods: {
    hideDropdown () {
      this.activeItem = null
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/scale';
@import 'beisheim/scss/colors';
@import 'beisheim/scss/font';
@import 'beisheim/scss/font-sizes';
@import 'beisheim/scss/breakpoints';

.main-navigation__list {
  display: flex;

  @include to(4) {
    @include font(-1);
  }
}

.main-navigation__item {
  position: relative;

  .router-link-exact-active,
  .router-link-active {
    .main-navigation__link {
      border-bottom: 1px solid gray(1);
    }
  }
}

.main-navigation__text {
  display: block;
  padding: 1.1375rem;

  &:hover, &:active {
    .main-navigation__link {
      border-bottom: 1px solid gray(1);
    }
  }
}

.dropdown-enter-active {
  transition: opacity 200ms ease-in-out;
}

.dropdown-leave-active {
  transition: opacity 50ms ease-in-out;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;

  .sub-navigation__item {
    opacity: 0;
    transform: translateY(-20px);
  }
}

</style>
